export class NewSubjectForm {
  static readonly type = '[Contract] NewSubjectForm';
  constructor(public value: any, public name: string) {}
}
